import { render, staticRenderFns } from "./MinesStatisticsItem.vue?vue&type=template&id=16490e09&scoped=true&"
import script from "./MinesStatisticsItem.vue?vue&type=script&lang=js&"
export * from "./MinesStatisticsItem.vue?vue&type=script&lang=js&"
import style0 from "./MinesStatisticsItem.vue?vue&type=style&index=0&id=16490e09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16490e09",
  null
  
)

export default component.exports